import { createSelector } from '@reduxjs/toolkit';

const getState = (state) => state.adminOrders;

export const adminOrdersSelector = createSelector(getState, (state) => state.orders);
export const adminOrdersMetaSelector = createSelector(getState, (state) => state.ordersMeta);
export const isLoadingOrdersSelector = createSelector(getState, (state) => state.isLoadingUsers);

export const selectedAdminOrderSelector = createSelector(getState, (state) => state.selectedOrder);
export const isLoadingOrderSelector = createSelector(getState, (state) => state.isLoadingOrder);

export const adminOrderErrorsSelector = createSelector(getState, (state) => state.errors);
